<span [innerHTML]="truncateChar(text)" *ngIf="text"
      [ngbPopover]="tipContent" placement="right" triggers="mouseenter:mouseleave"
      [disablePopover]="isDisabled()"></span>
<ng-template #tipContent><span [innerHTML]="text"></span></ng-template>
